import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'gas-panel',
  templateUrl: './gas-panel.component.html',
  styleUrls: ['./gas-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasPanelComponent {
  @Output('onClick')
  public onClick$ = new EventEmitter<void>();

  @Input()
  public title = '';

  @Input()
  public subtitle = '';

  @Input()
  public subtitleRef: TemplateRef<HTMLElement>;

  @Input()
  public buttonText = '';

  @Input()
  public iconName = '';

  @Input()
  public iconClassName = '';

  @Input()
  public iconSize = 40;

  public clickHandler(): void {
    this.onClick$.emit();
  }
}
